import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CheckmarkIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CheckmarkIcon(props: CheckmarkIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CheckmarkIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        d="M18.8316 8.40775C19.2014 8.77757 19.2322 9.35803 18.924 9.76296L18.8316 9.86875L11.0396 17.6607C10.6698 18.0306 10.0893 18.0614 9.68437 17.7532L9.57858 17.6607L5.68258 13.7648C5.27913 13.3613 5.27914 12.7072 5.68258 12.3037C6.0524 11.9339 6.63286 11.9031 7.03779 12.2113L7.14358 12.3037L10.3095 15.4681L17.3706 8.40775C17.7404 8.03793 18.3209 8.00711 18.7258 8.31529L18.8316 8.40775Z"
        fill="#23B998"
      />
    </svg>
  )
}
